import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";

const ChartPie = ({ color1, color2, color3, color4, color5, height, width, dashboardObj }) => {

   const [categoryWiseProsArr, setCategoryWiseProsArr] = useState([])
   const [categoryWiseProsCountArr, setCategoryWiseProsCountArr] = useState([])
   const [proCount, setProCount] = useState(false)

   useEffect(() => {
      if (Object.keys(dashboardObj).length > 0) {
         let categoryWiseProsArr = dashboardObj?.category_wise_pro?.map(item => {
            if (item.category_display_name_chr === "Home Check-Up") {
               return "Home Inspector";
            }
            return item.category_display_name_chr;
         });
         let categoryWiseProsCountArr = dashboardObj?.category_wise_pro?.map(item => item.category_wise_pro_count);

         setCategoryWiseProsArr(categoryWiseProsArr);
         setCategoryWiseProsCountArr(categoryWiseProsCountArr);
      }
   }, [dashboardObj])


   const data = {
      datasets: [
         {
            // data: categoryWiseProsCountArr.length > 0 ? categoryWiseProsCountArr : [45, 25, 20, 10],
            data: categoryWiseProsCountArr,

            borderWidth: 0,
            backgroundColor: [
               `${color1 ? color1 : "rgba(255, 159, 64, 1)"}`,    // Solid orange
               `${color2 ? color2 : "rgba(255, 159, 64, 0.8)"}`,  // Lighter orange (70% opacity)
               `${color3 ? color3 : "rgba(255, 159, 64, 0.6)"}`,  // Even lighter orange (50% opacity)
               `${color4 ? color4 : "rgba(255, 159, 64, 0.4)"}`,  // Very light orange (30% opacity)
               `${color5 ? color5 : "rgba(255, 159, 64, 0.2)"}`,  // Very light orange (30% opacity)
            ],
            hoverBackgroundColor: [
               `${color1 ? color1 : "rgba(255, 159, 64, 1)"}`,
               `${color2 ? color2 : "rgba(255, 159, 64, 0.8)"}`,
               `${color3 ? color3 : "rgba(255, 159, 64, 0.6)"}`,
               `${color4 ? color4 : "rgba(255, 159, 64, 0.4)"}`,
               `${color5 ? color5 : "rgba(255, 159, 64, 0.2)"}`,
            ],
         },
      ],
      // labels: categoryWiseProsArr.length > 0 ? categoryWiseProsArr : ["Plumber", "Electrician", "HVAC", "Other"], // Added a label for the fourth slice
      labels: categoryWiseProsArr, // Added a label for the fourth slice
   };

   const options = {
      plugins: {
         legend: {
            display: true,
            position: 'bottom', // Positions the legend below the chart
         },
         responsive: true,
      },
      maintainAspectRatio: false,
   };


   useEffect(() => {
      setProCount(categoryWiseProsCountArr.some((element) => element !== 0))
   }, [categoryWiseProsCountArr])

   return (
      <>
         {proCount ?
            <Pie className="piechart" style={{ maxHeight: '300px', height: '300px' }} data={data} options={options} />
            :
            <span>{'No data found'}</span>
         }
      </>
   );
};

export default ChartPie;
